
import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = "md", className = "" }) => {
  const sizeClasses = {
    sm: "h-8",
    md: "h-10",
    lg: "h-14",
  };

  return (
    <Link to="/" className={`flex items-center gap-2 ${className}`}>
      <div className="relative">
        <div className={`${sizeClasses[size]} aspect-square rounded-lg bg-gradient-to-br from-purple-400 to-primary flex items-center justify-center`}>
          <div className="grid grid-cols-3 grid-rows-3 gap-0.5 p-1.5">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
              <div 
                key={num} 
                className={`w-full h-full ${num === 5 ? 'bg-primary/80' : 'bg-white/80'} rounded`}
              >
                {num === 5 && <div className="w-1.5 h-1.5 bg-white rounded-full m-auto"></div>}
              </div>
            ))}
          </div>
        </div>
        <div className="absolute -bottom-1 -right-1 h-4 w-4 bg-everyday rounded-md rotate-12"></div>
      </div>
      <span className={`font-bold ${size === "sm" ? "text-lg" : size === "md" ? "text-2xl" : "text-3xl"}`}>
        Calculator
      </span>
    </Link>
  );
};

export default Logo;
